import { ReactNode } from 'react'
import { ButtonProps } from 'react-bootstrap'

import styled from 'styled-components'

import { CSSBase } from './CSSBase'
import { CSSBasePrimary } from './CSSBasePrimary'

export interface IconButtonProps extends ButtonProps {
  children: ReactNode | string
  variant?: 'primary' | 'secondary'
  onClick?: React.MouseEventHandler<HTMLButtonElement>
}
export const IconButton = styled.button<IconButtonProps>`
  ${CSSBase}

  ${({ variant = 'primary' }) => (variant === 'primary' ? CSSBasePrimary : '')}
`
